<template>
  <el-dialog
    custom-class="c-dialog"
    :visible.sync="show"
    :show-close="false"
    @cancle="close"
    :title="title"
    :width="width"
    append-to-body
    :close-on-click-modal="false"
  >
    <div slot="title" class="c-dialog__title">{{ title }}</div>
    <div class="c-dialog__body">
      <slot></slot>
      <div class="c-dialog__footer">
        <el-button
          v-if="showConfirm"
          round
          size="small"
          type="primary"
          icon="iconfont icon-queren"
          @click="confirm"
          >确定</el-button
        >
        <el-button
          v-if="showClose"
          round
          size="small"
          icon="iconfont icon-guanbi"
          class="mg-left-50"
          @click="close"
          >关闭</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
// import CustomInputNumber from "../Auto/CustomInputNumber/CustomInputNumber.vue";
import * as PoiApi from "@/views/poi/api";
export default {
  components: {
    // CustomInputNumber
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    actionType: {
      //操作类型，是新增还是编辑,还是查看详情
      type: String,
      validator(val) {
        return ["add", "edit", "detail"].indexOf(val) != -1;
      },
      default: "add",
    },
    width: {
      type: [String, Number],
      default() {
        return "607px";
      },
    },
    title: {
      type: String,
      default: "",
    },
    showConfirm: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: this.visible,
    };
  },
  computed: {},
  methods: {
    close() {
      this.show = false;
      this.$emit("update:visible", false);
      this.$emit("close", false);
    },

    confirm() {
      this.$emit("ok");
    },
  },
  watch: {
    visible(val) {
      this.show = val;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .c-dialog {
  background: #eaeef1;
  border-radius: 10px;
  .el-dialog__header {
    padding: 30px;
    padding-bottom: 0px !important;
  }
  .el-dialog__body {
    padding: 30px;
  }
  &__title {
    height: 55px;
    display: flex;
    align-items: center;
    background: #fff;
    color: #48b7eb;
    font-size: 22px;
    padding-left: 20px;
  }
  &__body {
    background: #fff;
    min-height: 354px;
    padding: 40px;
  }
  &__footer {
    background: #fff;
    text-align: center;
    .el-button {
      font-size: 16px;

      &--small {
        padding: 10px 20px;
      }
      &--primary {
        background-color: #23aaea;
        border-color: #23aaea;
      }
      .iconfont {
        margin-right: 20px;
      }
    }
  }
}
</style>